import {HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {AppSettingsService} from '../app/appSettings.service';
import {GroupingConfiguration} from '../../model/configuration/groupingConfiguration.model';
import { Observable } from 'rxjs/Observable';
import { catchError, tap } from 'rxjs/operators';
import 'rxjs/add/observable/throw';
import {PanelConfigurationIndicators} from '../../model/configuration/panelConfigurationIndicators.model';
import {PanelConfigurationNonWorkingDay} from '../../model/configuration/panelConfigurationNonWorkingDay.model';
import { PanelConfigurationIndicatorWorkingDay } from 'src/app/model/configuration/panelConfigurationWorkingDay.model';
import {PanelConfigurationChartMetadata} from '../../model/configuration/panelConfigurationChartMetadata.model';

@Injectable()
export class  ConfigurationService {

  private url_root: string;
  private headersConfig: HttpHeaders;

  constructor(private http: HttpClient, private settingsService: AppSettingsService) {
    this.url_root = `${settingsService.getApiAddress()}/`;
    this.headersConfig = settingsService.getHeadersConfig();
  }

  listPanelConfigurationUserQueueStatus() {
    return this.http.get(`${this.url_root}WorkflowConfigurations/ListPanelConfigurationUserQueueStatus`, { headers: this.headersConfig });
  }

  listPanelConfigurationIndicators() {
    return this.http.get(`${this.url_root}WorkflowConfigurations/ListPanelConfigurationIndicators`, { headers: this.headersConfig });
  }

  listGroupingConfigurations() {
    return this.http.get(`${this.url_root}WorkflowConfigurations/ListGroupingConfigurations`, { headers: this.headersConfig });
  }

  listInteractionQueueConfigurations() {
    return this.http.get(`${this.url_root}WorkflowConfigurations/ListPanelConfigurationUserQueueStatus`, { headers: this.headersConfig });
  }

  getPagedGroupingConfigurations(pageIndex: number, pageSize: number) {
    return this.http.get(`${this.url_root}api/WorkflowConfigurations/GetPagedGroupingConfigurations?pageIndex=${pageIndex}`
      , { headers: this.headersConfig });
  }

  saveGroupingConfiguration(config: GroupingConfiguration) {
    return this.http.post(`${this.url_root}WorkflowConfigurations/SaveGroupingConfiguration`, config, { headers: this.headersConfig });
  }

  saveInteractionQueueConfiguration(config: any) {
    return this.http.post(`${this.url_root}WorkflowConfigurations/SavePanelConfigurationUserQueueStatus`, config, { headers: this.headersConfig });
  }

  saveInteractionQueueConfigurationList(configs: any) {
    return this.http.post(`${this.url_root}WorkflowConfigurations/SavePanelConfigurationUserQueueStatusList`, configs, { headers: this.headersConfig });
  }

  deleteGroupingConfiguration(groupingConfigurationId: number) {
    return this.http.get(`${this.url_root}WorkflowConfigurations/DeleteGroupingConfiguration?id=${groupingConfigurationId}`,
      { headers: this.headersConfig });
  }

  deleteInteractionQueueConfiguration(configId: number) {
    return this.http.get(`${this.url_root}WorkflowConfigurations/DeletePanelConfigurationUserQueueStatus?id=${configId}`,
      { headers: this.headersConfig });
  }

  savePanelConfigurationIndicators(panelConfigurationIndicator: PanelConfigurationIndicators) {
    return this.http.post(`${this.url_root}WorkflowConfigurations/SavePanelConfigurationIndicators`
      , panelConfigurationIndicator, { headers: this.headersConfig });
  }

  deletePanelConfigurationIndicators(panelConfigurationIndicatorId: number) {
    return this.http.get(`${this.url_root}WorkflowConfigurations/DeletePanelConfigurationIndicators?id=${panelConfigurationIndicatorId}`,
      { headers: this.headersConfig });
  }

  listPanelConfigurationIndicatorsWorkingDay(businessProcess, state) {
    return this.http.get(`${this.url_root}WorkflowConfigurations/GetPanelConfigurationIndicatorWorkingDays?bpId=${businessProcess}&stId=${state}`, { headers: this.headersConfig });
  }

  saveNonWorkingDay(nonWorkingDay: PanelConfigurationNonWorkingDay) {
    return this.http.post(`${this.url_root}WorkflowConfigurations/SaveNonWorkingDay`, nonWorkingDay
      , { headers: this.headersConfig });
  }

  saveWorkingDay(workingDay: PanelConfigurationIndicatorWorkingDay) {
    return this.http.post(`${this.url_root}WorkflowConfigurations/SavePanelConfigurationIndicatorWorkingDays`, workingDay
      , { headers: this.headersConfig });
  }

  deleteNonWorkingDay(id: number) {
    return this.http.get(`${this.url_root}WorkflowConfigurations/DeleteNonWorkingDay?id=${id}`,
      { headers: this.headersConfig });
  }

  deleteWorkingDay(businessProcessId: number, stateId: number) {
    return this.http.get(`${this.url_root}WorkflowConfigurations/DeletePanelConfigurationIndicator?pn=${businessProcessId}&st=${stateId}`
      , { headers: this.headersConfig });
  }

  listNonWorkingDays() {
    return this.http.get(`${this.url_root}WorkflowConfigurations/ListNonWorkingDays`, { headers: this.headersConfig });
  }

  listPanelConfigurationChartMetadata() {
    return this.http.get(`${this.url_root}WorkflowConfigurations/ListPanelConfigurationApprovalChart`, { headers: this.headersConfig });
  }

  savePanelConfigurationChartMetadata(chartMetadata: PanelConfigurationChartMetadata) {
    return this.http.post(`${this.url_root}WorkflowConfigurations/SavePanelConfigurationApprovalChart`, chartMetadata
      , { headers: this.headersConfig });
  }

  deletePanelConfigurationChartMetadata(id: number) {
    return this.http.get(`${this.url_root}WorkflowConfigurations/DeletePanelConfigurationApprovalChart?id=${id}`,
      { headers: this.headersConfig });
  }
}
